import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
  TemplateRef,
  ViewChildren,
} from '@angular/core';
import { Category, Option, Pipeline } from '@telespot/protocols/data-access';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ts-protocol-panel',
    templateUrl: './protocol-panel.component.html',
    styleUrls: ['./protocol-panel.component.scss'],
    standalone: false
})
export class ProtocoloPanelComponent implements AfterViewInit, OnDestroy {
  //#region Paramenters

  private readonly destroy$ = new Subject<void>();

  //#endregion

  //#region Inputs

  @Input() sectionTemplate: TemplateRef<unknown>;
  @Input() labelTemplate: TemplateRef<unknown>;

  @Input() pipelines: Pipeline[] = [];
  @Input() categories: Record<string, Category> = {};
  @Input() options: Record<string, Option> = {};

  @Input() collapsed = false;
  @Input() loading = true;
  @Input() disableDragAndDrop = false;

  //#endregion

  //#region Outputs

  @Output() connectedDropListChanged = new EventEmitter<string[]>();
  @Output() labelSelected = new EventEmitter<Option>();

  //#endregion

  //#region Children

  @ViewChildren('label') labels: QueryList<ElementRef>;

  //#endregion

  //#region Constructor

  constructor(private readonly translateService: TranslateService) {}

  //#endregion

  //#region Life Cycle Methods

  public ngAfterViewInit(): void {
    this.labels.changes.pipe(takeUntil(this.destroy$)).subscribe((labels) => this.registerDropLists(labels));
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.connectedDropListChanged.emit([]);
  }

  //#endregion

  //#region Public Methods

  public selectLabel(label: Option) {
    this.labelSelected.emit(label);
  }

  public get lang(): string {
    return this.translateService.currentLang;
  }

  //#endregion

  //#region Private Methods

  private registerDropLists(rows: QueryList<ElementRef>) {
    const internalDropLists = rows.map((row) => row.nativeElement.id);

    this.connectedDropListChanged.emit(internalDropLists);
  }

  //#endregion
}
